import {type ComponentProps} from 'react';
import {twMerge} from 'tailwind-merge';

type DocumentMetaProps = {
  className?: ComponentProps<'div'>['className'];
  effectiveDate: string;
  lastUpdatedDate: string;
  version: string;
};

function DocumentMeta({
  className,
  effectiveDate,
  lastUpdatedDate,
  version,
}: DocumentMetaProps) {
  return (
    <div className={twMerge('flex flex-col gap-1 text-sm', className)}>
      <span>{`Version ${version}`}</span>
      <span>{`Effective Date: ${effectiveDate}`}</span>
      {lastUpdatedDate && <span>{`Last updated: ${lastUpdatedDate}`}</span>}
    </div>
  );
}

export default DocumentMeta;
